export { default } from "./LessonOverviewVocabButton";
